exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawAreaInner_wrap {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative; }\n  .drawAreaInner_wrap > canvas {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  .drawAreaInner_wrap #svg-area {\n    width: 100%;\n    height: 100%;\n    overflow: hidden; }\n    .drawAreaInner_wrap #svg-area > svg {\n      position: absolute;\n      top: 50% !important;\n      left: 50% !important; }\n  .drawAreaInner_wrap #control-area {\n    position: absolute;\n    top: 0;\n    left: 0; }\n", ""]);

// exports
